// 引入文件
import request from "../utils/request";

/**
 *  老师加盟
 * @method post
 * @return {[type]}         [description]
 */
export function postJoin(data) {
  return request({
    url: "Agent/Join",
    method: "post",
    "Content-Type": "application/x-www-form-urlencoded",
    data
  });
}

/**
 *  申请试读
 * @method post
 * @return {[type]}         [description]
 */
export function postSignup(data) {
  data.hasOwnProperty("applySource") || (data.applySource = 5);
  data.hasOwnProperty('verifyCode') || (data.verifyCode = '88888888');

  return request({
    // url: 'http://192.168.111.253:8099/hatu/apply/addApply',
    // url: "https://crm.ihatoo.com:8099/hatu/apply/addApply",
    url: "v2/operation/api/static/apply",
    method: "post",
    "Content-Type": "application/x-www-form-urlencoded",
    data
  });
}

/**
 *  发送验证码
 * @method post
 * @return {[type]}         [description]
 */
export function SendSms(data) {
  data.hasOwnProperty("applySource") || (data.applySource = 5);

  return request({
    // url: "https://crm.ihatoo.com:8099/hatu/studentManage/SendSms",
    url: "v2/sys/api/static/send/sms",
    method: "post",
    "Content-Type": "application/x-www-form-urlencoded",
    data
  });
}

// 获取课程列表
export function getCourseList(data) {
    return request({
        url: 'https://api.ihatoo.net/operation/crmProduct/productsByCategoryId',
        method: 'post',
        data
    })
}

// 获取教师列表
export function getTeacherList(data) {
    return request({
        url: 'https://api.ihatoo.net/operation/crmTeacher/list',
        method: 'post',
        data
    })
}

// 获取评论列表
export function getCommentList(data) {
    return request({
        url: 'https://api.ihatoo.net/operation/crmParentalComments/list',
        method: 'post',
        data
    })
}







// WEBPACK FOOTER //
// ./src/apis/league.js